/**
 * organizeArtifacts — "is this line something a previous organize pass
 * wrote?" Pure, and in its own file only so it can be unit-tested:
 * formatBellLine.js reaches useReminders → firebase/auth, which Jest can't
 * load (the undici / TextEncoder wall we've hit before).
 *
 * organizeReminderList strips its own old section headers before
 * re-classifying, or running it twice would accumulate them.
 *
 * Walter 2026-08-24 — the strip also has to catch a header that picked up a
 * BELL: "🔔 # OVERDUE". Pressing Enter at the end of a section header in the
 * Reminders list used to capture the header as an undated reminder, and the
 * bell then hid it from a leading-`#` test while making the line sort as a
 * reminder — so every subsequent organize re-filed it under UNDATED and it
 * could never be deleted for good. He accumulated ten. Capture no longer
 * creates them (lib/reminderDetect); this clears out the ones already in
 * people's lists on their next sort.
 */

const SECTION_NAMES = new Set([
  'OVERDUE', 'CURRENT', 'RECURRING', 'UNDATED', 'DONE',
  // Walter 2026-05-19: "LINES NOT PROCESSED" kept for backwards-
  // compatibility (existing lists may still have it as a stale header from a
  // prior organize). New runs emit the new label.
  'LINES NOT PROCESSED',
  "DOESN'T LOOK LIKE A REMINDER",
]);

const BELL_ANY_RE = /^(?:\[DONE\]|🔕|~~🔔|🔔)↻?\s?/;

/**
 * isOrganizeArtifactLine(raw) — true for a line that is one of organize's
 * own section headers, in any of the forms it has emitted or acquired:
 * `# CURRENT`, the old commented `// # CURRENT`, and the bell-prefixed
 * `🔔 # CURRENT`. Case-insensitive, so mixed-case output from the earliest
 * organize versions ("# Current") still gets cleaned.
 */
export function isOrganizeArtifactLine(raw) {
  let s = String(raw ?? '').trim();
  if (s.startsWith('//')) s = s.slice(2).trim();
  const bell = s.match(BELL_ANY_RE);
  if (bell) s = s.slice(bell[0].length).trim();
  if (!s.startsWith('#')) return false;
  s = s.replace(/^#+/, '').trim().toUpperCase();
  return SECTION_NAMES.has(s);
}

export { SECTION_NAMES };
